import stateClasses from "../data/stateClasses";

export default class Modal {

	constructor(triggerEl) {

		this.id = triggerEl.getAttribute('data-modal-id');
		this.triggerEl = triggerEl;
		this.modalEl = document.getElementById(this.id);
		this.modalContainer = this.modalEl.querySelector('.js-modal-container');
		this.closeButton = this.modalEl.querySelector('.js-modal-close-button');

		triggerEl.addEventListener('click', e => {
			e.preventDefault();
			
			const id = triggerEl.getAttribute('data-modal-id');
			const target = document.getElementById(id);

			if (target) {
				target.classList.add('is-open');
			}
		});

		// close modal on click
		this.modalEl.addEventListener('click', e => {
			e.preventDefault();
			this.close();
		});

		// prevent clicks inside container bubbling up
		this.modalContainer.addEventListener('click', e => e.stopPropagation());

		// close modal on close button clicks
		this.closeButton.addEventListener('click', e => {
			e.preventDefault();
			this.close();
		});
	}

	close() {
		this.modalEl.classList.remove(stateClasses.isOpen);
	}

}